angular.module('components.caDiscountMultiselect', [])
    .component('caDiscountMultiselect', {
        templateUrl: 'main/discountManagement/component/discountMultiselect.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            model: '=',
            choices: '<',
            placeholder: '<',
            filterBy: '<',
            orderBy: '<',
            disabledBy: '<',
            itemRenderer: '<'
        },
        controller: controller
});

// @ngInject
function controller($scope) {
    var vm = this;
    
    vm.filter = '';
    vm.filteredChoices = [];

    vm.$onChanges = onChanges;
    vm.$onInit = onInit;

    vm.filterChanged = filterChanged;
    vm.selectItem = selectItem;
    vm.deselectItem = deselectItem;
    vm.formatRenderer = formatRenderer;
    vm.hideSelected = false;

    vm.deselectSelection = deselectSelection;
    vm.selectFilterSelection = selectFilterSelection;
    vm.areThereItems = areThereItems;

    activate();


    function onInit() {
    }

    function activate(){
        $scope.$watch(function() {
            if(_.isUndefined(vm.model)){
                return vm.model;
            }
            
            return vm.model.length;
        },function(){
            filterChanged();
          });      
    }

    function areThereItems(){
        return vm.model.length > 0 || vm.filteredChoices.length > 0;
    }

    function onChanges(changes){
        if(vm.model === undefined){
            vm.model = [];
        }
        filterChanged();
    }

    function formatRenderer(value){
        var renderValue = '';
        _.forEach(vm.itemRenderer, function(item){
            renderValue += value[item] + ' ';
        })
        return renderValue;
    }

    function deselectItem(item){
        vm.filteredChoices.push(item);
        const index = vm.model.indexOf(item);
        vm.model.splice(index, 1);
    }

    function selectItem(item){
        vm.model.push(item);
        const index = vm.filteredChoices.indexOf(item);
        vm.filteredChoices.splice(index, 1);

        // Resets filter when we've selected an item and there are no more items after that.
        if(vm.filter !== '' && vm.filteredChoices.length === 0){
            vm.filter = '';
            filterChanged();
        }
    }

    function deselectSelection(){
        vm.model = [];
        vm.filter = "";
        filterChanged();
    }
    function selectFilterSelection(){
        vm.model = vm.model.concat(vm.filteredChoices)
        vm.filteredChoices = [];
        vm.filter = '';
        filterChanged();
    }

    function alreadyAdded(choice){
        var alreadyAdded = false;
        _.forEach(vm.model, function(item){
            var filterLength = vm.filterBy.length;
            _.forEach(vm.filterBy, function(by){
                if(item[by].toString().toLowerCase().includes(choice[by].toString().toLowerCase())){
                    filterLength--;
                }
            });
            if(filterLength === 0){
                alreadyAdded = true;
            }
        });
        return alreadyAdded;
    }
    
    function filterChanged(){
        console.log('FilterChanged start');
        vm.filteredChoices = vm.choices.filter( function (choice){
            if(alreadyAdded(choice))
                return false;

            if(vm.filter === '')
                return true;

            var match = false;
            _.forEach(vm.filterBy, function(by){
                if(choice[by].toString().toLowerCase().includes(vm.filter.toLowerCase())){
                    match = true;
                }
            });
            return match;
        });
        console.log('FilterChanged completed');
    }
}